"use strict";
// TODO ObservableRepositories that return Observables instead of Promises (but I don't want to bring in rxjs dep
//      just to type an interface)
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=repositories.js.map